// Single source of truth for the media/asset host. Update this once the
// CloudFront distribution is verified working, instead of editing every
// component that references it.
export const MEDIA_BASE_URL = 'https://d25ut0vhqgdazl.cloudfront.net';
